import Config from './Config';
let assetBase = Config.getAssetBase();
__webpack_public_path__ = assetBase; // eslint-disable-line no-undef
export default assetBase;
